import type { SearchParams } from '@/utils/parseSearchParamsToSearchQuery';

const projectFilterKeys = [
  'parkingSpace',
  'elevator',
  'usageType',
  'marketType',
  'propertyType',
  'searchString',
  'createdAt',
  'updatedAt',
  'tenantId',
] as const;

const projectFilterKeySet = new Set<string>(projectFilterKeys);

const hasValue = (value: unknown): boolean => {
  if (value === undefined || value === null || value === '') return false;
  if (typeof value !== 'object' || Array.isArray(value)) return true;

  return Object.values(value).some(hasValue);
};

export const getProjectListFilters = (filters: SearchParams = {}): SearchParams =>
  projectFilterKeys.reduce<SearchParams>((acc, key) => {
    const value = filters[key];

    if (hasValue(value)) {
      acc[key] = value;
    }

    return acc;
  }, {});

export const hasUnsupportedProjectFilters = (filters: SearchParams = {}) =>
  Object.entries(filters).some(([key, value]) => !projectFilterKeySet.has(key) && hasValue(value));
